// extracted by mini-css-extract-plugin
module.exports = {"actionsBtn":"ActionButton_actionsBtn__1jx8H","downloadImg":"ActionButton_downloadImg__1YNli"};